import { useEffect, useState } from 'react'

import { type ICommonField } from '@/app/types/common'
import { type ICompany } from '@/app/types/dmsTypes'

import { emptyCompanyData, type InputEvent } from '../../../helper'

interface IParams {
    data?: ICompany
}

export const useFields = (params: IParams) => {
    const { data } = params
    const _data: ICompany = data || emptyCompanyData

    const initialCompanyInn: ICommonField = {
        name: 'Инн компании',
        value: _data.inn || '',
        error: null,
        isTouched: false,
        placeholder: 'Инн компании'
    }

    const initialCompanyName: ICommonField = {
        name: 'Наименование компании',
        value: _data.name || '',
        error: null,
        isTouched: false,
        placeholder: 'Наименование компании'
    }

    const [inn, setInn] = useState<ICommonField>(initialCompanyInn)
    const [name, setName] = useState<ICommonField>(initialCompanyName)

    const onChangeInn = (e: InputEvent) => setInn((prev) => ({ ...prev, value: e.target.value }))
    const onChangeName = (e: InputEvent) => setName((prev) => ({ ...prev, value: e.target.value }))

    const onSetIsTouchedInn = () => setInn((prev) => ({ ...prev, isTouched: true }))
    const onSetIsTouchedName = () => setName((prev) => ({ ...prev, isTouched: true }))

    useEffect(() => {
        if (!inn.value) {
            setInn((prev) => ({ ...prev, error: 'Обязательное поле' }))
        } else if (inn.value && inn.value.length !== 10) {
            setInn((prev) => ({ ...prev, error: 'ИНН не должно привыжать 10 символов' }))
        } else {
            setInn((prev) => ({ ...prev, error: null }))
        }

        if (!name.value) {
            setName((prev) => ({ ...prev, error: 'Обязательное поле' }))
        } else {
            setName((prev) => ({ ...prev, error: null }))
        }
    }, [inn.value, setInn, name.value, setName])

    const onCheckIsToched = (): boolean => {
        if (inn.isTouched || name.isTouched) {
            return true
        }
        return false
    }

    const onSetTouchAll = () => {
        onSetIsTouchedInn()
        onSetIsTouchedName()
    }

    return {
        inn,
        onChangeInn,
        onSetIsTouchedInn,
        //
        name,
        onChangeName,
        onSetIsTouchedName,
        //
        isSomeToched: onCheckIsToched(),
        onSetTouchAll
    }
}
